module.exports = __webpack_public_path__ + "static/img/philosophy.625cde5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/philosophy.png
// module id = rNnD
// module chunks = 1